//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debug from 'debug'
import { mapState } from 'vuex'
import SquareStarSvg from '@/assets/svg/square-star.svg?inline'
import VueQrCode from 'vue-qrcode'
import waypointMixin from '@/mixins/waypoint'
import phoneAnimationImages from '@/scripts/phoneAnimationImages'

const DesktopBG = require('@/assets/img/white-background-sm.png')
const MobileBG = require('@/assets/img/white-background-ar-mobile.png')

const log = debug('HomeAR')

export default {
  name: 'HomeAR',
  components: { SquareStarSvg, VueQrCode },
  mixins: [waypointMixin],
  data() {
    return {
      url: '/ar-redirect', // temp until mounted
      phoneAnimationIndex: 0,
      phoneAnimationPaused: false,
      phoneAnimaitonTimestamp: null,
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
    bgImage() {
      return this.isMobile !== true ? DesktopBG : MobileBG
    },
  },
  mounted() {
    log('HomeAR')
    this.setUrl()
    this.updateCanvasSize()
    this.ctx = this.canvas.getContext('2d')
    this.preloadImages()

    window.addEventListener('resize', this.updateCanvasSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCanvasSize)
  },
  methods: {
    setUrl() {
      this.url = new URL(`${window.location.origin}/ar-redirect`).href
    },
    updateCanvasSize() {
      const ratio = 0.954
      this.canvas = this.$refs.canvas
      this.canvas.height = this.canvas.offsetHeight
      this.canvas.width = this.canvas.height * ratio
      this.canvas.style.width = `${this.canvas.width}px`
    },
    preloadImages() {
      this.images = []
      this.loadedImageCount = 0
      const numImages = phoneAnimationImages.length

      for (let i = 0; i < numImages; i++) {
        const img = new Image()
        img.src = phoneAnimationImages[i]
        img.onload = () => {
          this.loadedImageCount++
          if (this.loadedImageCount >= numImages) {
            this.animateImages()
          }
        }
        this.images.push(img)
      }
    },
    animateImages() {
      if (this.phoneAnimationPaused) {
        this.phoneAnimaitonTimestamp = null
        return
      }

      requestAnimationFrame((timestamp) => {
        if (this.phoneAnimaitonTimestamp === null) {
          this.phoneAnimaitonTimestamp = timestamp
        }

        const img = this.images[this.phoneAnimationIndex]

        try {
          this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
          this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height)
        } catch (e) {
          // console.error(e)
          // console.log('Index', this.phoneAnimationIndex)
        }

        const delta = timestamp - this.phoneAnimaitonTimestamp
        const numFrames = phoneAnimationImages.length
        if (delta > 30) {
          if (this.phoneAnimationIndex === numFrames - 1) {
            this.increment = false
          } else if (this.phoneAnimationIndex === 0) {
            this.increment = true
          }

          let nextFrame
          const frameJump = Math.floor(delta / 30)
          if (this.increment) {
            nextFrame = this.phoneAnimationIndex + frameJump
          } else {
            nextFrame = this.phoneAnimationIndex - frameJump
          }
          if (nextFrame >= numFrames) {
            this.increment = false
            nextFrame = numFrames - (nextFrame % numFrames) - 1
          } else if (nextFrame < 0) {
            this.increment = true
            nextFrame = -nextFrame
          }

          this.phoneAnimationIndex = nextFrame
          this.phoneAnimaitonTimestamp = timestamp
        }

        this.animateImages()
      })
    },
    togglePhoneAnimation() {
      this.phoneAnimationPaused = !this.phoneAnimationPaused

      if (!this.phoneAnimationPaused) {
        this.animateImages()
      }
    },
  },
}
